import { put, takeLatest, all } from "redux-saga/effects";
import axios from "axios";
import { GET_VIDEOS, UPDATE_VIDEOS_STATUS, DELETE_VIDEOS, ADD_VIDEO, EDIT_VIDEO, UPDATE_VIDEO_ORDER_STATUS } from "../Constants";
import { defaultHeaders } from "../Constants/DefaultHeaders";
import { logout } from "../../utils";
import { GetVideosSuccess, GetVideosFailure, UpdateVideosStatusSuccess, UpdateVideosStatusFailure, DeleteVideosSuccess, DeleteVideosFailure, AddVideoSuccess, AddVideoFailure, EditVideoSuccess, EditVideoFailure, UpdateVideoOrderStatusSuccess, UpdateVideoOrderStatusFailure } from "../Actions/VideosAction";

function* GetVideosRequest(actions) {
  try {
    const res = yield axios.get(`${process.env.REACT_APP_API_URL}api/admin/videos?status=${actions.payload.status}`, { headers: defaultHeaders() });
    if (res.status === 200) {
      yield put(GetVideosSuccess(res.data));
    } else {
      yield put(GetVideosFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(GetVideosFailure(e));
  }
}

function* UpdateVideosStatusRequest(actions) {
  const body = {
    id: actions.payload.id,
    status: actions.payload.status,
  };
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/change_video_status`, body, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(UpdateVideosStatusSuccess(res.data));
    } else {
      yield put(UpdateVideosStatusFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(UpdateVideosStatusFailure(e));
  }
}

function* DeleteVideoRequest(actions) {
  try {
    const res = yield axios.delete(`${process.env.REACT_APP_API_URL}api/admin/video/${actions.payload}`, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(DeleteVideosSuccess(res.data));
    } else {
      yield put(DeleteVideosFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(DeleteVideosFailure(e));
  }
}

function* AddVideoRequest(actions) {
  const body = {
    // id: actions.payload.id,
    title: actions.payload.title,
    video_url: actions.payload.video_url,
  };

  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/add_video`, body, { headers: defaultHeaders() });
    if (res.status === 200) {
      yield put(AddVideoSuccess(res.data));
    } else {
      yield put(AddVideoFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(AddVideoFailure(e));
  }
}

function* EditVideoRequest(actions) {
  const body = {
    id: actions.payload.id,
    title: actions.payload.title,
    video_url: actions.payload.video_url,
  };

  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/edit_video`, body, { headers: defaultHeaders() });
    if (res.status === 200) {
      yield put(EditVideoSuccess(res.data));
    } else {
      yield put(EditVideoFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(EditVideoFailure(e));
  }
}

function* videoOrderStatusRequest(actions) {
  let data = [];
  actions.payload.map((arr) => {
    data.push(arr);
  });
  const body = {
    data,
  };

  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/change_video_order_number`, body, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(UpdateVideoOrderStatusSuccess(res.data));
    } else yield put(UpdateVideoOrderStatusFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(UpdateVideoOrderStatusFailure(e));
  }
}

function* actionWatcher() {
  yield takeLatest(GET_VIDEOS, GetVideosRequest);
  yield takeLatest(UPDATE_VIDEOS_STATUS, UpdateVideosStatusRequest);
  yield takeLatest(DELETE_VIDEOS, DeleteVideoRequest);
  yield takeLatest(ADD_VIDEO, AddVideoRequest);
  yield takeLatest(EDIT_VIDEO, EditVideoRequest);
  yield takeLatest(UPDATE_VIDEO_ORDER_STATUS, videoOrderStatusRequest);
}

export default function* VideosSaga() {
  yield all([actionWatcher()]);
}
